import { render, staticRenderFns } from "./Contactt.vue?vue&type=template&id=5444459c&scoped=true&"
import script from "./Contactt.vue?vue&type=script&lang=js&"
export * from "./Contactt.vue?vue&type=script&lang=js&"
import style0 from "./Contactt.vue?vue&type=style&index=0&id=5444459c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5444459c",
  null
  
)

export default component.exports